import { HttpClient, JSON_STRING } from "../../services/http/http-client";
import { SETTINGS_URL } from "../../services/common-urls";
import { CONTACTS_URL, MODIFICATION_URL } from "../../modules/booking/services/booking-service";

export const FieldService = {
  insertField: ({
    field_label,
    external_table
  }) => {
    return HttpClient.post(SETTINGS_URL, {
      section: 'bsettings',
      action: 'add_custom_field',
      field_label,
      external_table,
    })
  },
  findFields: ({
    moduleURL = '/booking.pl',
    external_id,
    external_table,
    section = ''
  }) => HttpClient.post(moduleURL, {
    external_id,
    external_table,
    action: 'get_custom_data',
    section,
    output: JSON_STRING,
  }),
  updateField: ({
    kVal,
    value,
  }) => HttpClient.post(MODIFICATION_URL, {
    key: 'custom_data_id',
    kVal,
    name:'data',
    value,
    table: 'custom_data'
  })
}